/* eslint-disable no-undef */
import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as TickIcon } from 'Assets/svg/tick-icon-new.svg';
import { ReactComponent as TripleDotNavIcon } from 'Assets/svg/triple-dot-nav.svg';
import Button from 'Components/common/Button';
import { NEW_INTEGRATION_NOT_AVAILABLE_CRMS } from 'Utils/constants';
import Utils from 'Utils/utils';

const AdvanceActionWrapper = props => {
  const { sublinks, integrationType, disconnectCallback = () => {} } = props;
  return (
    <div className="advance-action-wrapper">
      <TripleDotNavIcon />
      <div className="advance-action-list-wrapper">
        {sublinks.length > 0 && (
          <>
            {sublinks.map((item, index) => {
              const { titleText, linkValue, isNavLink } = item;
              return (
                <div
                  className="advance-action-item-wrapper"
                  key={`advance-action-item-${integrationType}-${index}`}
                >
                  <Link
                    // onClick={e => redirectToPath(e, id)}
                    data-path={linkValue}
                    to={linkValue}
                  >
                    {titleText}
                  </Link>
                </div>
              );
            })}
          </>
        )}
        <div
          className="advance-action-item-wrapper disconnect-wrapper"
          onClick={e => disconnectCallback(e, integrationType)}
        >
          Disconnect
        </div>
      </div>
    </div>
  );
};

const IntegrationItemWrapper = props => {
  const {
    dataMap = {},
    integrationType,
    isLoading = false,
    connectCallback = () => {},
    isConnected,
  } = props;

  const { title, description, sublinks = [], isSvg } = dataMap;

  return (
    <div
      className={`integration-item-wrapper ${integrationType.toLowerCase()}`}
    >
      <div className="title-wrapper">
        <div className="left-wrapper">
          {isSvg ? (
            <dataMap.imgComponent className="svg-icon" />
          ) : (
            <img src={dataMap.imgComponent} alt={title} className="svg-icon" />
          )}
          <span>{title}</span>
        </div>
        {isConnected &&
          !NEW_INTEGRATION_NOT_AVAILABLE_CRMS.includes(integrationType) && (
            <AdvanceActionWrapper sublinks={sublinks} {...props} />
          )}
      </div>
      {description && <div className="description-wrapper">{description}</div>}

      {isConnected ? (
        <div className="connected-btn">
          <TickIcon />
          Connected
        </div>
      ) : (
        <Button
          btnText="Connect"
          icon={false}
          iconName=""
          type="button"
          className={`action-btn${isLoading ? ' loading' : ''}`}
          loader={isLoading}
          click={e => connectCallback(e, integrationType)}
        />
      )}
    </div>
  );
};

export default IntegrationItemWrapper;
export { IntegrationItemWrapper };
